import Color from 'color';
import { getDarkenColor } from './'

export default (type, colors) => {
  const lvShadowVals = `1px 1px 0 0`;

  const styles = {
    default: {
      'p-contribute__option__button': {
        customCSS: `
          .p-contribute__option .button {
            background-color: ${colors.primary};
            box-shadow: ${lvShadowVals} ${getDarkenColor(colors.primary, 0.07)};
          }
          .p-contribute__option .button:hover, 
          .p-contribute__option .button:focus{
              background-color: ${Color(colors.primary).darken(0.05)};
              box-shadow: ${lvShadowVals} ${Color(getDarkenColor(colors.primary, 0.07)).darken(0.05)};
          }
        `
      }
    },
    type1: {
      'contribute__beta': {
        margin: 0,
        fontSize: '24px',
        padding: '25px 0',
        fontWeight: 'bold',
        color: colors.primary,
      },
      'contribute__title': {
        fontSize: '33px',
        minHeight: 'auto',
        color: colors.primary,
        justifyContent: 'center'
      },
      'contribute__content__lead': {
        textAlign: 'center',
        color: colors.dark,
        lineHeight: '29px',
        fontSize: '24px',
      },
      'contribute__icon': {
        color: '#C4C4C4', // TODO: Replace from account settings
      },
      'contribute__option': {
        border: 'none'
      },
      'contribute__description': {
        lineHeight: '19px',
        fontSize: '16px',
        color: '#000'
      },
      'p-contribute__option__button': {
        backgroundColor: colors.secondary,
        borderRadius: '3px',
        padding: '14px 0',
        boxShadow: 'none',
        marginTop: '24px',
        fontSize: '14px',
        width: '121px',
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/contribute.js